import PropTypes from 'prop-types'
import { Search } from '../../stories/atoms/icons/core'
import { iconSizeOptions } from '../../stories/atoms/icons/icons-sizes'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../stories/fundamentals/text-styles/constants'
import SearchComponent from '../../stories/molecules/search'
import { searchVariantsOptions } from '../../stories/molecules/search/constants'
import { SearchContainer } from '../styled-components'
import { useIntl } from 'react-intl'

const RecursiveListSearch = ({ setSearchValue, searchValue }) => {
  const { formatMessage } = useIntl()

  return (
    <SearchContainer>
      <SearchComponent.Root
        placeholder={formatMessage({ id: 'search' })}
        variant={searchVariantsOptions.DESKTOP}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        defaultDesktopVariantOpen={true}
        startFocued
      >
        <SearchComponent.Container>
          <SearchComponent.LeadingIcon
            icon={Search}
            size={iconSizeOptions['ICON-S']}
            style={{
              marginLeft: '8px'
            }}
          />
          <SearchComponent.Input
            style={{
              ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']],
              ...textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]
            }}
          />
          <SearchComponent.ClearButton />
        </SearchComponent.Container>
        <SearchComponent.CancelButton />
      </SearchComponent.Root>
    </SearchContainer>
  )
}

RecursiveListSearch.propTypes = {
  setSearchValue: PropTypes.func,
  searchValue: PropTypes.string
}

export default RecursiveListSearch
